import { Api_routes, server_url } from '../config/API_Routes';
import { deleteRequest, getRequest, postRequest, putRequest } from '../config/axios-config';


const getEmailList = (queryParams, signal) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.inboxListEmails,
        queryParams,
        undefined,
        signal
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const modifyEmail = (id, body) => {
  return new Promise(async (resolve, reject) => {
    console.log(body);
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.modifyEmail + '/' + id,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const starEmails = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.starEmails,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const unstarEmails = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.unstarEmails,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const readEmail = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.readEmail,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const archiveEmails = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.archiveEmails,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const unArchiveEmails = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.unArchiveEmails,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const moveToBin = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.moveToBin,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getEmailThreads = (args) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.emailThreads + '/' + args?.emailId
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const searchInfluencerEmail = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.searchEmail,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const searchInfluencerForSendingEmail = (query) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.searchInfluencerForSendingEmail,
        query
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const deleteEmails = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.deleteEmails,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const emptyBin = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.emptyBin,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const hideInfluencerEmails = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.hideInfluencerEmails,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const sendEmailFromInbox = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.sendEmailInbox,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getEmailsForIIV = (profileId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getEmailsForIIV + '/' + profileId
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getAllSnippets = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getAllSnippets
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getUnreadEmailsCount = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getUnreadEmailsCount
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const createInboxSnippet = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createInboxSnippet,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const updateInboxSnippet = (id, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await putRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateInboxSnippet + '/' + id,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const deleteInboxSnippet = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await deleteRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.deleteInboxSnippet + '/' + id
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const dismissFollowup = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.dismissFollowup,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getInboxTourStatus = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.inboxTour
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const completeInboxTour = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.inboxTour,
        {}
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getFollowupEmails = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getFollowupEmails
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

export {
  getEmailList,
  starEmails,
  unstarEmails,
  readEmail,
  archiveEmails,
  unArchiveEmails,
  moveToBin,
  getEmailThreads,
  searchInfluencerEmail,
  deleteEmails,
  emptyBin,
  hideInfluencerEmails,
  modifyEmail,
  sendEmailFromInbox,
  searchInfluencerForSendingEmail,
  getEmailsForIIV,
  getAllSnippets,
  getUnreadEmailsCount,
  createInboxSnippet,
  updateInboxSnippet,
  deleteInboxSnippet,
  dismissFollowup,
  getFollowupEmails,
  getInboxTourStatus,
  completeInboxTour,
};